// 设置app detail信息
export const SET_APP_DETAIL = 'SET_APP_DETAIL'

export const PUSH_APP_STACK = 'PUSH_APP_STACK'

export const POP_APP_STACK = 'POP_APP_STACK'
